
import React from "react"
import { CategoryUtils } from "../utils/CategoryUtils"

const ListCategories = ({ categories, primary_category }) => {

    var _categories = [];

    if (categories) {
        if (categories.nodes) {
            _categories = categories.nodes;
        } else if (typeof categories === typeof []) {
            _categories = categories;
        }
    }

    var firstSubCat = 0;
    var resArr = [];

    let _cat = []
    if (_categories && _categories !== undefined && _categories !== null) {
        _cat = _categories.map(el => el);
    }

    _cat.filter(function(item){
        var i = resArr.findIndex(x => x.name === item.name);
        if(i <= -1){
        resArr.push(item);
        }
        return null;
    });

    return <React.Fragment>
        {

            resArr.map(function (category) {
                var link_to = ""
                if (category.name === primary_category) {
                    return ""
                } else if (category.slug.startsWith("topic-")) {
                    link_to = category.slug.replace("topic-","")
                }
                else {
                    link_to = new CategoryUtils(category.slug).link
                }

                firstSubCat++;
                return <a
                    onClick={(event) => { event.stopPropagation(); }}
                    className={firstSubCat<2?"mag_subcategories_first mag_subcategories":"mag_subcategories"}
                    rel="category" key={category.name} style={{width: "fit-content"}} href={link_to}>
                    <div style={{
                        marginLeft:firstSubCat<2?"0px":"30px",
                        backgroundColor: "#EBF5FF",
                        color: "#1F92A0",
                        fontSize: "13px",
                        borderRadius: "5px",
                        textAlign: "center",
                        // height:"33px",
                        textTransform: "uppercase",
                        width: "fit-content",
                        padding: "1px 10px 1px 10px",
                        whiteSpace: 'nowrap'
                    }}
                    >
                    {category.name}
                    </div>
                </a>;
                }
            )
        }
    </React.Fragment>;

}

export default ListCategories;